<template>
	<div class="news">
		<template v-if="headerShow">
			<div class="newsBox">
				<indexTitle :title="$t('图像处理')" @goMore="goMore"></indexTitle>
				<div class="newsBox_two">
					<indexNewsList :list='list'></indexNewsList>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="newsBox newsBoxH5">
				<indexTitle :title="$t('功能应用')" @goMore="goMore"></indexTitle>
				<div class="newsBox_two">
					<indexNewsList :list='list'></indexNewsList>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import indexTitle from "./indexTitle.vue"
	import indexNewsList from "./indexNewsList.vue"
	export default {
		components: {
			indexTitle,
			indexNewsList
		},
		data() {
			return {
				list: [
					// {
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022.11.01',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布'
					// },
					// {
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022.11.01',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布'
					// },
					// {
					// 	name:'AQ-300 4K超高清内镜系统正式发布',
					// 	time:'2022.11.01',
					// 	cen:'[The Endless Frontier 无尽的前沿],澳华全新一代旗舰产品，AQ-300 4K超高清内镜系统正式发布啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊'
					// },
				]
			}
		},
		mounted() {

		},
		methods: {
			goMore() {
				this.$router.push('/news')
			},
			setList(e) {
				this.list = e;
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.news {
		width: 100%;

		// min-height: 100vh;
		.newsBox {
			margin: 0 auto;
			width: 1200px;
			padding-bottom: 160px;
			box-sizing: border-box;

		}

		.newsBox_two {
			width: 1200px;
			// overflow: hidden;
		}
	}

	@media screen and (max-width:1200px) {
		.newsBoxH5 {
			max-width: 100% !important;
			width: 100% !important;
			padding-bottom: 30px !important;
			.newsBox_two {
				max-width: 100% !important;
				width: 100% !important;
			}
		}

	}
</style>